import type { FC, PropsWithChildren } from 'react';
import { useContext, createContext, useState } from 'react';

export const VirtualPageAnalyticsContext = createContext<{
  virtualPageAnalyticsData: {
    previousStep?: string;
    setPreviousStep: (activeStep?: string) => void;
  };
}>({
  virtualPageAnalyticsData: {
    setPreviousStep: () => {},
    previousStep: undefined,
  },
});

export const VirtualPageAnalyticsProvider: FC<PropsWithChildren> = ({ children }) => {
  const [previousStep, setPreviousStep] = useState<string | undefined>(undefined);

  return (
    <VirtualPageAnalyticsContext.Provider
      value={{
        virtualPageAnalyticsData: {
          previousStep,
          setPreviousStep,
        },
      }}
    >
      {children}
    </VirtualPageAnalyticsContext.Provider>
  );
};

export const useVirtualPageAnalyticsData = () => {
  const ctx = useContext(VirtualPageAnalyticsContext);

  return {
    virtualPageAnalyticsContext: ctx,
  };
};
